import { LoadingContainer, ModelList } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { Page } from 'core/components'
import { useCreditAgenciesList } from 'core/types'

const CreditAgencies = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: creditAgencies, isLoading } = useCreditAgenciesList({
    companyId,
    query: { limit: 100 },
  })

  useClickAction({
    label: 'Create Credit Agency',
    onClick: () => history.push(`${url}/create`),
  })

  useClickAction({
    label: 'Generate Credit Report',
    onClick: () => history.push(`${url}/generate-credit-report`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <ModelList
          json={creditAgencies}
          title='Credit Agencies'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreditAgencies
